module.exports = __webpack_public_path__ + "assets/f2f7f57f5449ff28d3d441664d375762.ico";